import { render, staticRenderFns } from "./ETFSingle.vue?vue&type=template&id=78088d24"
import script from "./ETFSingle.vue?vue&type=script&lang=js"
export * from "./ETFSingle.vue?vue&type=script&lang=js"
import style0 from "./ETFSingle.vue?vue&type=style&index=0&id=78088d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports